<script lang="ts">
	import { toastStore } from '$lib/stores/toast.svelte';
	import Icon from '$lib/components/ui/Icon.svelte';

	const typeStyles = {
		info: 'bg-warm-900/90 dark:bg-warm-800/95 text-sky-400 border-sky-500/30',
		success: 'bg-warm-900/90 dark:bg-warm-800/95 text-emerald-400 border-emerald-500/30',
		warning: 'bg-warm-900/90 dark:bg-warm-800/95 text-amber-400 border-amber-500/30',
		error: 'bg-warm-900/90 dark:bg-warm-800/95 text-rose-400 border-rose-500/30'
	};
</script>

<aside
	aria-label="Notifications"
	class="fixed bottom-2 right-2 sm:bottom-5 sm:right-5 z-50 flex flex-col gap-2.5 max-w-[calc(100vw-1rem)] sm:max-w-sm w-full pointer-events-none px-4 sm:px-0"
>
	{#each toastStore.toasts as toast (toast.id)}
		<div
			class="pointer-events-auto flex items-center justify-between gap-3 px-4 py-3 rounded-xl backdrop-blur-md shadow-xl border text-sm font-medium animate-in slide-in-from-bottom-3 duration-200 {typeStyles[
				toast.type
			]}"
			data-testid="toast"
		>
			<div class="flex items-center gap-2.5">
				{#if toast.type === 'success'}
					<Icon name="success" class="w-5 h-5 shrink-0" />
				{:else if toast.type === 'error'}
					<Icon name="alert" class="w-5 h-5 shrink-0" />
				{:else if toast.type === 'warning'}
					<Icon name="warning" class="w-5 h-5 shrink-0" />
				{:else}
					<Icon name="info" class="w-5 h-5 shrink-0" />
				{/if}
				<span class="text-warm-200 dark:text-warm-100">{toast.message}</span>
			</div>
			<button
				type="button"
				onclick={() => toastStore.dismiss(toast.id)}
				aria-label="Dismiss notification"
				class="text-warm-400 dark:text-warm-400 hover:text-white p-1 rounded-md transition-colors"
			>
				<Icon name="close" class="w-4 h-4" />
			</button>
		</div>
	{/each}
</aside>
